import { topicItems } from '@/mocks/home';

const colorMap: Record<string, string> = {
  primary: 'bg-primary-100 text-primary-700 hover:bg-primary-200',
  accent: 'bg-accent-100 text-accent-700 hover:bg-accent-200',
  secondary: 'bg-secondary-100 text-secondary-700 hover:bg-secondary-200',
};

export default function TopicsSection() {
  return (
    <section id="topics" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-[1000px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <span className="inline-block px-3 py-1 rounded-full bg-accent-100 text-accent-700 text-xs font-semibold mb-3">
            话题标签
          </span>
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">
            热门追剧话题
          </h2>
          <p className="text-sm text-foreground-500 mt-2">大家都在讨论的热剧和话题</p>
        </div>
        <div className="flex flex-wrap justify-center gap-3">
          {topicItems.map((topic) => (
            <a
              key={topic.label}
              href="#topics"
              className={`inline-flex items-center gap-2 px-4 py-2.5 rounded-full text-sm font-semibold transition-colors whitespace-nowrap cursor-pointer ${colorMap[topic.color] || colorMap.primary}`}
            >
              <span>{topic.label}</span>
              <span className="text-[11px] opacity-60">{topic.hot}</span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}